var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVerMovimentos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 16V19C20 22.3137 22.6863 25 26 25C29.3137 25 32 22.3137 32 19V16C32 12.6863 29.3137 10 26 10C22.6863 10 20 12.6863 20 16ZM28 19C28 20.1046 27.1046 21 26 21C24.8954 21 24 20.1046 24 19V16C24 14.8954 24.8954 14 26 14C27.1046 14 28 14.8954 28 16V19Z",
    fill: "#15D4B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 16V19C48 22.3137 50.6863 25 54 25C57.3137 25 60 22.3137 60 19V16C60 12.6863 57.3137 10 54 10C50.6863 10 48 12.6863 48 16ZM56 19C56 20.1046 55.1046 21 54 21C52.8954 21 52 20.1046 52 19V16C52 14.8954 52.8954 14 54 14C55.1046 14 56 14.8954 56 16V19Z",
    fill: "#15D4B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.999 20C14.6856 20 12 22.686 12 26V54C12 57.3137 14.6863 60 18 60H62C65.3147 60 68 57.3159 68 54.0033V39C68 37.8954 68.8954 37 70 37C71.1045 37 72 37.8954 72 39V54.0033C72 59.5272 67.5217 64 62 64H18C12.4771 64 8 59.5228 8 54V26C8 20.4775 12.4759 16 17.999 16H21C22.1046 16 23 16.8954 23 18C23 19.1046 22.1046 20 21 20H17.999ZM29 18C29 16.8954 29.8954 16 31 16H50C51.1046 16 52 16.8954 52 18C52 19.1046 51.1046 20 50 20H31C29.8954 20 29 19.1046 29 18ZM57 18C57 16.8954 57.8954 16 59 16H61.9999C67.5227 16 72 20.4771 72 26V28C72 31.3137 69.3137 34 66 34H18C16.8954 34 16 33.1046 16 32C16 30.8954 16.8954 30 18 30H66C67.1045 30 68 29.1046 68 28V26C68 22.6863 65.3136 20 61.9999 20H59C57.8954 20 57 19.1046 57 18Z",
    fill: "#15D4B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVerMovimentos);
export default __webpack_public_path__ + "static/media/iconVerMovimentos.9d7221ec5da6f052bdd85ecd3015a44a.svg";
export { ForwardRef as ReactComponent };